export default {
  props: {
    el: {
      required: true,
    },
    customMode: {
      type: Boolean,
      default: false,
    },
    document: {
      default: () => {},
    },
    recipient: {
      default: () => -1,
    },
  },
  computed: {
    color() {
      return this.el.color.startsWith("#") ? this.el.color : `rgb(${this.el.color})`;
    },
  },

  methods: {
    onFocus() {
      this.$emit("on-selected", {
        id: this.el,
      });
    },
    onDragEnd(ev) {
      const {
        target: { offsetLeft, offsetTop, parentElement },
      } = ev;

      this.$emit("end-drag", {
        id: this.el.id,
        page_id: parentElement
          .closest(".pdf_container_wrapper")
          .querySelector("canvas.display")?.id,
        left: offsetLeft,
        top: offsetTop <= this.el.baseHeight - this.el.height ? offsetTop : null,
      });
    },
    onRemove(event) {
      this.$emit("remove-drag", this.el.id);
    },
  },
};
